import React from 'react'
import rocketIcon from '../../assets/images/rocketIcon.png'
import surpriseMeIcon from '../../assets/images/surpriseStarIcon.png'

const SuggestionButton = ({
    children,
    className = '',
    ...props
}) => {
    return (
        <button
            type='button'
            className={` w-fit rounded-[8px] px-[12px] py-[8px] text-gray-primary bg-[#FCFCFD] border border-[#C3CAD4] flex items-center gap-[8px] ${className}`}
            {...props}
        >
            <img src={children === "Surprise me" ? surpriseMeIcon : rocketIcon} className='h-[16px] aspect-auto' alt="rocket icon" />
            <p className='text-[13px] leading-[16px]'> {children}</p>
        </button>
    )
}

export default SuggestionButton